/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { permissions } from './constants';

export const checkPermission = (permissionsToBeChecked: string[], assignedPermissions: string[]) => {
  let permission = false;
  if (permissionsToBeChecked.includes(permissions.allowAll) ||
    permissionsToBeChecked.some(item => {
      if (item.indexOf(",") === -1) {
        return assignedPermissions.includes(item);
      } else {
        let list = item.split(",");
        return list.every(listItem => assignedPermissions.includes(listItem));
      }
    })) {
    permission = true;
  }
  return permission;
};

export const checkAllPermission = (permissionsToBeChecked: string[], assignedPermissions: string[]) => {
  return permissionsToBeChecked.every(item => assignedPermissions.includes(item));
};

export const checkResourcePermission = (action: string, resource: any) => {
    return resource ? resource.entity.actions.includes(action) : false;
}